import Product from '../models/Product';

export const DEFAULT_CONGRESS_PRODUCTS: Partial<Product>[] = [
  {
    code: 'KBCGGG0026',
    nameProduct: 'BOLSA CORP.  PLASTICO RECICLA BLANCA 30 x 40  PAQ. 25 UN.',
    idLanguage: 'ES',
    isEnabled: '',
    isOnDemand: false,
    businessUnit: 'resto',
    productType: 'bolsas',
    family: 'merchandising',
    price: 0,
    availableWW: 999,
    lowest: 1,
    multiple: 1,
  },
  {
    code: 'KBGGGG0003',
    nameProduct: 'BOLSAS NYLON ANTRACITA MESOESTETIC',
    idLanguage: 'ES',
    isEnabled: '',
    isOnDemand: false,
    businessUnit: 'resto',
    productType: 'bolsas',
    family: 'merchandising',
    price: 0,
    availableWW: 999,
    lowest: 1,
    multiple: 1,
  },
];
